<template>
  <div class="layout">
    <div class="header-wrap">
      <v-header />
    </div>
    <div class="container">
      <div class="aside-wrap">
        <side-bar />
      </div>
      <div class="main-wrap">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import VHeader from './header'
import SideBar from './menu/sidebar'
import mixin from '@/mixins/layout'

export default {
  name: 'main-layout',
  components: {
    SideBar,
    VHeader
  },
  mixins: [mixin]
}
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100%;
  overflow: hidden;

  display: flex;
  flex-direction: column;

  .container {
    height: 0;
    flex: 1;

    display: flex;
  }

  .header-wrap {
    height: 60px;
    flex-shrink: 0;
    background-color: #001529;
    position: relative;
  }

  .aside-wrap {
    width: 200px;
    flex-shrink: 0;
    background-color: #001529;
    overflow: hidden auto;
  }

  .scrollbar {
    width: 100%;
    height: 100%;
    overflow: hidden;

    & /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .main-wrap {
    width: 0;
    flex: 1;
    padding: 20px;
    overflow: hidden auto;
    display: flex;
    flex-direction: column;

    & > div {
      flex: 1;
      border-radius: 4px;
      padding: 20px;
      background-color: #fff;
    }
  }
}
</style>
